module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/taranto.e910acba0e8ad76a4f51dcc85062bd1c.jpg";